import { reconciliationStates, visioGlobeSelectedColor } from '../../../const';
import { autoQuantity } from '../../../utils/formatUtils';

const { jQuery } = window;
const vg = window.visioweb;

const footfallImages = {
  0: '/static/footfall/red.png',
  1: '/static/footfall/orange.png',
  2: '/static/footfall/darkYellow.png',
  3: '/static/footfall/yellow.png',
  4: '/static/footfall/lightGreen.png',
  5: '/static/footfall/green.png',
};

export default class MapViewer {
  mapviewer;
  mapServerURL = 'https://mapserver.visioglobe.com/';
  mapDescriptorName = '/descriptor.json';
  footfallPois = [];
  footfallPopup = null;
  footfallPopupId = null;
  query = {};
  useMouseover = false;
  initialPoi = '';
  initialFloor = '0';
  initialAnimation = 500;
  cameraType = 'orthographic'; // 'orthographic';
  showSidebar = false;
  activePlaceColor = visioGlobeSelectedColor;
  pathColor = '#19E0FF';
  floorButtonIDs = [];
  baseZoomFactor = 1.5;
  isReady = false;
  appParams = {};
  accessibleRoute = false;
  useNavigation = true; // activate the turn by turn navigation if available
  instructionsOverlayVisible = true;
  changeFloorAnimationDuration = 10; // change floor animation duration in ms.
  animationOffset = 0;
  animationValue = 0;
  colorMap = {};
  currentlySelectedColors = [];
  isMobile = false;
  isMappingMode = false;
  divId = null;
  callback = null;
  storesData = [];
  selectPoiCallback = () => {
  };

  constructor(mapHash, pcId, isMobile, isMappingMode, divId, callback) {
    this.mapServerURL = 'https://mapserver.visioglobe.com/';
    this.mapDescriptorName = '/descriptor.json';
    this.pcId = pcId;
    this.isReady = false;
    this.isMobile = isMobile;
    this.isMappingMode = isMappingMode;
    this.query = {};
    this.useMouseover = false;
    this.initialPoi = '';
    this.initialFloor = '0';
    this.initialAnimation = 500;
    this.cameraType = 'orthographic'; // 'orthographic';
    this.activePlaceColor = '#cf13c6';
    this.pathColor = '#19E0FF';
    this.baseZoomFactor = 1.5;
    this.divId = divId;
    this.appParams = {};
    this.accessibleRoute = false;
    this.useNavigation = true; // activate the turn by turn navigation if available
    this.instructionsOverlayVisible = true;
    this.changeFloorAnimationDuration = 300; // change floor animation duration in ms.

    this.mapURL = this.mapServerURL + mapHash + this.mapDescriptorName;
    this.start(callback);
  }

  getFloors = () => this.mapviewer.getFloors().map(elt => ({ name: elt.name, index: elt.index }));

  getCurrentFloor = () => this.mapviewer.getFloors().filter(elt => elt.name === this.mapviewer.getCurrentFloor())[0];

  zoomIn = () =>
    this.mapviewer.camera.goTo({
      ...this.mapviewer.camera.position,
      radius: this.mapviewer.camera.position.radius / 1.5,
    });

  zoomOut = () =>
    this.mapviewer.camera.goTo({
      ...this.mapviewer.camera.position,
      radius: this.mapviewer.camera.position.radius * 1.5,
    });

  updateFloor = (floor) => {
    if (floor && this.getCurrentFloor() && floor.index !== this.getCurrentFloor().index) {
      let tab = [0, 2];
      if (floor.index > this.getCurrentFloor().index) {
        tab = [2, 0];
      }
      if (!this.isMobile) {
        const baseRad = this.mapviewer.camera.position.radius;

        this.mapviewer.camera.goTo({
          ...this.mapviewer.camera.position,
          radius: baseRad * tab[0],
        }, { animationDuration: this.changeFloorAnimationDuration }).then(() => {
          this.mapviewer.camera.goTo({
            ...this.mapviewer.camera.position,
            radius: baseRad * tab[1],
          }, { animationDuration: 0 });
          this.mapviewer.camera.goTo({
            ...this.mapviewer.camera.position,
            radius: baseRad,
          }, { animationDuration: this.changeFloorAnimationDuration });
        });
      }
    }
    return this.mapviewer.changeFloor(floor.name, { animationDuration: this.changeFloorAnimationDuration });
  }

  destroyMap = () => {
    this.mapviewer.stop();
    this.mapviewer.unloadMap();
  };

  start = (callback) => {
    if (this.isWebGLSupported()) {
      document.addEventListener('mapviewerready', () => {
        if (this.isReady) {
          return;
        }
        this.isReady = true;
        if (typeof (vg) === 'undefined') {
          console.log('ERROR: Missing VisioWeb SDK...probably missing script file vg.mapviewer.web.js or not loaded yet');
          return;
        }
        if ((navigator.platform.indexOf('iPhone') != -1) ||
          (navigator.platform.indexOf('iPad') != -1) ||
          (navigator.platform.indexOf('iPod') != -1) ||
          (navigator.userAgent.indexOf('ndroid') != -1)) {
          // to prevent rubberband scrolling on mobile safari.
          // document.body.addEventListener('touchmove', (event) => {
          //   if (event.target !== jQuery('#vg_search')[0] &&
          //     event.target !== jQuery('#vg_route_from')[0] &&
          //     event.target !== jQuery('#vg_route_to')[0]) {
          //     event.preventDefault();
          //   }
          // }, false);
        }

        // prepare progress bar
        if (jQuery().knob !== undefined) {
          jQuery('.knob').knob();
        }

        this.query = vg.Utils.getURLParameters();

        const map = this.mapURL;
        if (typeof (this.query.bundle) !== 'undefined') {
          map = `../data.bundles/${this.query.bundle}/map.json`;
        } else if (typeof (this.query.url) !== 'undefined') {
          map = this.query.url;
        } else if (typeof (this.query.hash) !== 'undefined') {
          map = `https://mapserver.visioglobe.com/${this.query.hash}/descriptor.json`;
        }

        if (typeof (this.query.initialfloor) !== 'undefined') {
          this.initialFloor = this.query.initialfloor;
        }
        if (typeof (this.query.initialpoi) !== 'undefined') {
          this.initialPoi = this.query.initialpoi;
        }
        if (typeof (this.query.initialanimation) !== 'undefined') {
          this.initialAnimation = this.query.initialanimation;
        }
        if (typeof (this.query.cameratype) !== 'undefined') {
          this.cameraType = this.query.cameratype;
        }
        if (typeof (this.query.sidebar) !== 'undefined') {
          this.showSidebar = this.query.sidebar != 'no';
        }
        // if (this.showSidebar) {
        //   jQuery('#vg_sidebar').show();
        //   jQuery('#vg_mapviewer').css('right', '300px');
        // }
        if (typeof (this.query.activeplacecolor) === 'string') {
          this.activePlaceColor = `#${this.query.activeplacecolor}`;
        }
        if (typeof (this.query.pathcolor) === 'string') {
          this.pathColor = `#${this.query.pathcolor}`;
        }
        const mapviewerParameters = {
          logoPosition: 'TOP_RIGHT',
          path: map,
          cameraType: this.cameraType,
          antialias: this.query.antialias,
          initialFloorName: this.initialFloor,
          onObjectMouseUp: this.onObjectMouseUp,
          progressHandler: this.updateProgress,
        };

        // set use_mouseover to have the status bar on mouseover
        // the VisioWeb mapviewer will have higher performance without mouseover
        if (this.useMouseOver || typeof (this.query.mouseover) !== 'undefined') {
          mapviewerParameters.onObjectMouseOver = this.onObjectMouseOver;
          mapviewerParameters.onObjectMouseOut = this.onObjectMouseOut;
        }
        this.mapviewer = new vg.Mapviewer();
        this.mapviewer.initialize(jQuery(`#${this.divId}`)[0], mapviewerParameters)
          .then(() => this.onLoadCompleted(callback))
          .catch((result) => {
            const message = 'Unknown map initialize error';
            if (typeof (result) !== 'undefined' && typeof (result.message) !== 'undefined') {
              message = `Map initialize error: ${result.message}`;
            }
            console.log(message);
          });
      });
    } else {
      alert('Your browser does not have WebGL support, update or try another browser, no map will be loaded or displayed');
    }
  };

  setSelectStoreCallback = (callback) => {
    this.selectStoreCallback = callback;
  }

  onLoadCompleted = (callback) => {
    callback();
    this.mapviewer.camera.rotationManipulatorEnabled = true;
    this.mapviewer.camera.goTo({
      ...this.mapviewer.camera.position,
      radius: this.mapviewer.camera.position.radius / this.baseZoomFactor,
    }, { animationDuration: 0 });

    if (this.query && this.query.remote) {
      //  window.addEventListener('message', this.onRemoteMessage, false);
      parent.postMessage('mapviewerready', '*');
    }

    // this.logVisioWebTitle();

    jQuery('#progress').hide();
    // jQuery(window).resize((event) => {
    //   this.mapviewer.resize(jQuery('#container').width(), jQuery('#container').height());
    // });

    // handles the case where VisioWeb is integrated inside a mobile app through a WebView
    // if (typeof (sendToMobileApp) === 'function') {
    //   this.mapviewer.on('mouseup', sendToMobileApp);
    // }

    // Start the rendering of the map.
    this.mapviewer.start();

    // if (typeof (enableStats) === 'boolean' && enableStats) {
    //   this.mapviewer.setLogStatistic(true);
    //   if (typeof (statURL) !== 'undefined') {
    //     this.mapviewer.setLogStatisticURL(statURL);
    //   }
    //   this.mapviewer.camera.track = true;
    // }
    //
    // const extraData = this.mapviewer.getExtraData();
    // if (extraData && typeof (extraData.app_params) !== 'undefined') {
    //   this.appParams = extraData.app_params;
    // }
    // if (typeof (this.appParams.navigationParams) !== 'undefined') {
    //   this.useNavigation = this.appParams.navigationParams.navigationViewAvailable;
    // }
    //
    // // if (!this.loadPlaces()) {
    // //   this.loadLabels();
    // // }
    //
    // if (typeof (this.query.viewtype) !== 'undefined') {
    //   this.viewType = this.query.viewtype;
    // }
    // const animationType = 'translation';
    // if (typeof (this.query.animationtype) !== 'undefined') {
    //   this.animationType = this.query.animationtype;
    // }
    // if (this.cameraType === 'orthographic') {
    //   // viewType = 'multibuilding'; // to see the floors in 3D when using a pitch != -90.0 (see verticalPitch below)
    // }
    // const possibleViewTypes = ['singlefloor', 'multifloor', 'multibuilding'];
    // if (typeof (viewType) !== 'undefined' && possibleViewTypes.indexOf(this.viewType) !== -1) {
    //   this.mapviewer.setupMultiBuildingView({
    //     containerDivSelector: '#container',
    //     viewType: this.viewType,
    //     animationType
    //   });
    //   this.mapviewer.multiBuildingView.buildingModeEnabled = (this.viewType === 'multifloor');
    //   if (this.cameraType !== 'orthographic' && typeof (this.appParams.exploreParams) !== 'undefined') {
    //     this.mapviewer.camera.pitch = this.appParams.exploreParams.pitch;
    //     this.mapviewer.multiBuildingView.floorModePitch = this.appParams.exploreParams.pitch;
    //   }
    //   this.mapviewer.cameraDrivenExplorer.setEnabled(true);
    //   this.mapviewer.cameraDrivenExplorer.maxExploreDistance = 300.0;
    //   if (typeof (this.appParams.cameraDrivenExplorer) !== 'undefined') {
    //     this.mapviewer.cameraDrivenExplorer.setEnabled(this.appParams.cameraDrivenExplorer.enabled);
    //     this.mapviewer.cameraDrivenExplorer.maxExploreDistance = this.appParams.cameraDrivenExplorer.distanceThreshold;
    //   }
    //   this.setupMultiBuildingUI();
    //   return this.mapviewer.multiBuildingView.goTo({
    //     mode: 'global',
    //     buildingID: this.mapviewer.multiBuildingView.DEFAULT
    //   })
    //     .then(this.setupInitialPosition)
    //     .then(this.doRoutingFromURLParameters);
    // }

    //  this.setupDefaultUI();
    //   return this.setupInitialPosition()
    //     .then(this.doRoutingFromURLParameters);
  };

  // #region: View setup -----------------------------------------

  /*
   * Customizes how the map looks at the beginning.
   */
  setupInitialPosition = () => {
    // Places that are highlighted at the start/load of the page.
    // setActivePlace(mapviewer.getPlace('B3-UL01-ID0014'));
    if (this.initialPoi !== '') {
      if (this.mapviewer.multiBuildingView) {
        // start in an specific floor in multibuilding mode.
        const parameters = {
          mode: 'floor',
          place: this.initialPoi,
          animationDuration: this.initialAnimation,
        };
        return this.mapviewer.multiBuildingView.goTo(parameters)
          .catch(e =>
            // if for example that floor does not exist, fallback to "global" which will always do something.
            this.mapviewer.multiBuildingView.goTo({
              mode: 'global',
              buildingID: this.mapviewer.multiBuildingView.DEFAULT,
              floorID: this.mapviewer.multiBuildingView.DEFAULT,
              animationDuration: this.initialAnimation,
            }));
      }

      const { floor } = this.mapviewer.getPlace(this.initialPoi).vg;
      return this.mapviewer.changeFloor(floor)
        .then(() => this.mapviewer.camera.goTo(this.initialPoi, { animationDuration: this.initialAnimation * 1000 }))
        .catch(e => this.mapviewer.changeFloor(this.mapviewer.getFloors()[0].name, { animationDuration: this.initialAnimation * 1000 }));
    } else if (this.initialFloor !== '') {
      if (this.mapviewer.multiBuildingView) {
        // start in an specific floor in multibuilding mode.
        const parameters = {
          mode: 'floor',
          floorID: this.initialFloor,
          animationDuration: this.initialAnimation,
        };
        return this.mapviewer.multiBuildingView.goTo(parameters)
          .catch(e =>
            // if for example that floor does not exist, fallback to "global" which will always do something.
            this.mapviewer.multiBuildingView.goTo({
              mode: 'global',
              buildingID: this.mapviewer.multiBuildingView.DEFAULT,
              floorID: this.mapviewer.multiBuildingView.DEFAULT,
              animationDuration: this.initialAnimation,
            }));
      }

      return this.mapviewer.changeFloor(this.initialFloor, { animationDuration: this.initialAnimation * 1000 })
        .catch(e => this.mapviewer.changeFloor(this.mapviewer.getFloors()[0].name, { animationDuration: this.initialAnimation * 1000 }));
    }
  };

  /*
   * Go to that position. change floor if needed
   */
  gotoFloorAndPosition = (floor, position, postFunction) => {
    if (this.mapviewer.multiBuildingView) {
      return this.mapviewer.multiBuildingView.goTo({
        mode: 'floor',
        floorID: floor,
        viewpoint: {
          position,
        },
      });
    }

    const gotoFunction = () => this.mapviewer.camera.goTo(position, { animationDuration: 500 })
      .then(postFunction)
      .catch(console.log);

    if (this.mapviewer.getCurrentFloor() == floor) {
      return gotoFunction();
    }

    return this.mapviewer.changeFloor(floor, { animationDuration: this.changeFloorAnimationDuration }).then(gotoFunction).catch(console.log);
  };

  // #endregion
  // #region: UI setup -----------------------------------------
  setupBubbleUI = () => {
    jQuery('#place_bubble_set_origin').on('click', null, () => {
      const id = jQuery(this).attr('vg_id');
      this.routeStartID = id;
      this.routeWaypointIDs = [];
      // preselect comboboxes if exist
      const srcBox = jQuery('#vg_route_from');
      if (srcBox.length == 1) {
        const srcIndex = jQuery(`option[value="${id}"]`, srcBox).index();
        if (srcIndex != -1) {
          const srcBox0 = srcBox[0];
          srcBox0.selectedIndex = srcIndex;

          jQuery('#vg_route_from-input').val(jQuery(srcBox0[srcIndex]).val());
        }
      }

      this.closePlaceBubble();

      if (this.routeStartEnd == null) {
        this.routeStartEnd = new MyRoute(this.mapviewer);
      }
      if (this.routeStartEnd != null) {
        const place = this.mapviewer.getPlace(id);
        if (place) {
          const position = { x: place.vg.position.x, y: place.vg.position.y, z: 3 };
          this.routeStartEnd.remove();
          this.routeStartEnd.addStartPOI(place.vg.floor, position);
        }
      }

      this.doRouting(this.routeStartID, this.routeWaypointIDs.concat(this.routeEndID));
      return false;
    });
    jQuery('#place_bubble_set_destination').on('click', null, () => {
      const id = jQuery(this).attr('vg_id');
      routeEndID = id;

      // preselect comboboxes if exist
      const dstBox = jQuery('#vg_route_to');
      if (dstBox.length == 1) {
        const dstIndex = jQuery(`option[value="${id}"]`, dstBox).index();
        if (dstIndex != -1) {
          const dstBox0 = dstBox[0];
          dstBox0.selectedIndex = dstIndex;
          jQuery('#vg_route_to-input').val(jQuery(dstBox0[dstIndex]).val());
        }
      }

      this.closePlaceBubble();

      if (this.routeStartEnd == null) {
        this.routeStartEnd = new MyRoute(this.mapviewer);
      }
      if (routeStartEnd != null) {
        const place = this.mapviewer.getPlace(id);
        if (place) {
          const position = { x: place.vg.position.x, y: place.vg.position.y, z: 3 };
          routeStartEnd.remove();
          routeStartEnd.addEndPOI(place.vg.floor, position);
        }
      }
      this.doRouting(this.routeStartID, this.routeWaypointIDs.concat(this.routeEndID));
      return false;
    });
    jQuery('#place_bubble_set_waypoint').on('click', null, () => {
      const id = jQuery(this).attr('vg_id');
      this.routeWaypointIDs.push(id);

      this.closePlaceBubble();

      if (this.routeStartEnd == null) {
        this.routeStartEnd = new MyRoute(this.mapviewer);
      }
      if (this.routeStartEnd != null) {
        const place = this.mapviewer.getPlace(id);
        if (place) {
          const position = { x: place.vg.position.x, y: place.vg.position.y, z: 3 };
          // routeStartEnd.remove();
          this.routeStartEnd.addWaypointPOI(place.vg.floor, position);
        }
      }
      return false;
    });
    jQuery('#place_bubble_close_button').on('click', null, () => {
      this.closePlaceBubble();
      return false;
    });
    jQuery('#place_bubble_info_button').on('click', null, () => {
      if (jQuery('#place_bubble_description').is(':visible')) {
        jQuery('#place_bubble_description').hide();
        jQuery('#place_bubble_set_origin').show();
        jQuery('#place_bubble_set_destination').show();
        jQuery('#place_bubble_set_waypoint').show();
      } else {
        jQuery('#place_bubble_description').show();
        jQuery('#place_bubble_set_origin').hide();
        jQuery('#place_bubble_set_destination').hide();
        jQuery('#place_bubble_set_waypoint').hide();
      }
      return false;
    });
  }

  setupRouteUI = () => {
    this.mapviewer.on('routeComputed', (ev) => {
      jQuery('#route_clear').show();
    });
    jQuery('#route_clear').on('click', () => {
      clearRouting();
    });
    jQuery('#vg_toggles').on('click', '#toggle_handicap', () => {
      accessibleRoute = !accessibleRoute;
      jQuery('#toggle_handicap').prop('checked', accessibleRoute);

      // redo the routing is the box is check/unchecked and the is a route currently acive
      if (currentRoute != null) {
        doRouting();
      }
      return true;
    });
  }

  setupNavigationUI = () => {
    jQuery('#instructions_prev_button').on('click', null, () => {
      if (typeof (currentNavigation) === 'object' && this.currentNavigation !== null) {
        this.currentNavigation.displayPrevInstruction();
        this.updateNavigationUI();
      }
      return false;
    });
    jQuery('#instructions_next_button').on('click', null, () => {
      if (typeof (currentNavigation) === 'object' && this.currentNavigation !== null) {
        this.currentNavigation.displayNextInstruction();
        this.updateNavigationUI();
      }
      return false;
    });
    jQuery('#toggle_instructions').prop('checked', this.instructionsOverlayVisible);
    jQuery('#vg_toggles').on('click', '#toggle_instructions', () => {
      this.instructionsOverlayVisible = !this.instructionsOverlayVisible;
      jQuery('#toggle_instructions').prop('checked', this.instructionsOverlayVisible);
      this.toggleNavigationUI();
      return true;
    });
  };

  hideNavigationUI(complete) {
    const instructionsHeight = -(parseInt(jQuery('#instructions').height(), 10) + 2); // 2 for the 1 pixel border
    jQuery('#instructions').animate({
      bottom: `${instructionsHeight}px`,
    }, {
      complete,
    });
  }

  toggleNavigationUI = () => {
    if (instructionsOverlayVisible &&
      typeof (currentNavigation) === 'object' && currentNavigation !== null) {
      jQuery('#instructions').css('visibility', 'visible');
      jQuery('#instructions').animate({
        bottom: '0px',
      });
    } else {
      hideNavigationUI(() => {
        jQuery('#instructions').css('visibility', 'hidden');
      });
    }
  }

  resetNavigationUI = () => {
    jQuery('#instructions_detail').html('');
    jQuery('#instructions_brief').html('');
    jQuery('#instructions_count').html('');
    jQuery('#instructions_time').html('');
    jQuery('#instructions_icon').attr('src', '');
  }

  updateNavigationUI = () => {
    const numberOfInstructions = currentNavigation.getNbInstructions();
    const index = currentNavigation.getCurrentInstructionIndex();
    const instruction = currentNavigation.getInstructionData(index);
    if (instruction !== undefined) {
      /* It relies at least on the following images
          transit_instruction_end.png
          transit_instruction_down.png
          transit_instruction_up.png
          transit_instruction_start.png
          transit_instruction_straight.png
          transit_instruction_turn_gentle_left.png
          transit_instruction_turn_gentle_right.png
          transit_instruction_turn_left.png
          transit_instruction_turn_right.png
          transit_instruction_turn_sharp_left.png
          transit_instruction_turn_sharp_right.png
          transit_instruction_uturn_left.png
          transit_instruction_uturn_right.png
          transit_instruction_intermediate_destination.png
      */
      jQuery('#instructions_detail').html(instruction.detail);
      jQuery('#instructions_brief').html(instruction.brief);
      jQuery('#instructions_count').html(`${index + 1}/${numberOfInstructions}`);
      // since 1.7.10, if the instructions comes from javascript engine,
      // instruction.duration contains the duration in seconds, and durationString contains
      // for example 'in few minutes'
      // If the data comes from routing server, .duration will be the duration string.
      const durationString = (typeof (instruction.durationString) !== 'undefined') ? instruction.durationString : instruction.duration;
      jQuery('#instructions_time').html(durationString);
      jQuery('#instructions_icon').attr('src', `${vg.imagePath || '../media'}/${instruction.icon}`);
    }

    // Hide back or next instruction button.
    jQuery('#instructions_prev_button').show();
    jQuery('#instructions_next_button').show();
    // if it is first, do not show previous
    if (index == 0) {
      jQuery('#instructions_prev_button').hide();
    }
    // if it is last, do not show next, note the don't do an else, to handle case of just one instruction.
    if (index == (numberOfInstructions - 1)) {
      jQuery('#instructions_next_button').hide();
    }
  }

  setupSidebarUI = () => {
    if (jQuery().combobox !== undefined) {
      jQuery('.combobox').combobox();
    }

    if (this.mapviewer.getRoutingURL() !== '') {
      jQuery('#vg_route_to').bind('comboboxselected', (event, data, c) => {
        this.doRouting();
      });
      jQuery('#vg_route_from').bind('comboboxselected', (event, data, c) => {
        this.doRouting();
      });

      jQuery('#vg_route_to').bind('comboboxcleared', (event, data, c) => {
        this.clearRouting();
        this.routeEndID = false;
      });
      jQuery('#vg_route_from').bind('comboboxcleared', (event, data, c) => {
        this.clearRouting();
        this.routeStartID = false;
      });
      // Firefox clear combobox bug
      // There should be a better solution, this is somewhat heavy.
      jQuery('#vg_route_to ~ span > a > span.ui-icon-close').on('mouseup', (event, data, c) => {
        this.clearRouting();
        this.routeEndID = false;
        return false;
      });
      jQuery('#vg_route_from ~ span > a > span.ui-icon-close').on('mouseup', (event, data, c) => {
        this.clearRouting();
        this.routeStartID = false;
        return false;
      });
      jQuery('#vg_sidebar_routing').show();
    } else {
      jQuery('#vg_sidebar_routing').hide();
    }

    jQuery('#vg_search').bind('comboboxselected', () => {
      const jc = jQuery('#vg_search')[0];
      const opt = jc[jc.selectedIndex];
      const { value } = opt;
      if (value != '') {
        this.selectPlace(value);
      }
    });
    jQuery('#vg_search').bind('comboboxcleared', () => {
      this.resetActivePlace();
    });
    // Firefox clear combobox bug
    // There should be a better solution, this is somewhat heavy.
    jQuery('#vg_search ~ span > a > span.ui-icon-close').on('mouseup', (event, data, c) => {
      this.resetActivePlace();
      return false;
    });
  };

  setupDefaultUI = () => {
    if (this.showSidebar) {
      this.setupSidebarUI();
    }
    jQuery('#vg_footer').on('click', '.change_floor', () => {
      const targetFloor = jQuery(this).attr('data-floor');
      this.mapviewer.changeFloor(targetFloor, { animationDuration: this.changeFloorAnimationDuration }).catch(console.log);
      return false;
    });

    jQuery('#container').on('drag', (e) => {
      e.preventDefault();
      return false;
    });
    // Setup Change floor buttons.
    // No need to empty at beginning, and allows to add other things.
    const floors = this.mapviewer.getFloors();
    for (const i in floors) {
      const floor = floors[i];
      this.createFloorButton(floor.name);
    }
    jQuery('#floor_container').show();

    // select first floor by default
    this.updateActiveFloorButton(this.mapviewer.getCurrentFloor());

    // Add handler to update floor button
    // available since VisioKiosk (now named VisioWeb) 1.7.14
    this.mapviewer.on('floorChanged', (ev) => {
      const targetFloorName = ev.args.target;
      this.updateActiveFloorButton(targetFloorName);
    });

    // Routing will work on remote URLs and on local bundles, if a routing URL has been set.
    if (this.mapviewer.getRoutingURL() !== '') {
      this.setupBubbleUI();
      this.setupRouteUI();
      if (this.useNavigation) {
        this.setupNavigationUI();
      }
    }
  }

  /**
   * Setup selectors and listeners to update UI for current mode, building and floor.
   * It expects div #floor_container, #global_mode_button, #floor_mode_button, #change_building_select, #change_floor_select
   */
  setupMultiBuildingUI = () => {
    if (this.showSidebar) {
      this.setupSidebarUI();
    }

    if (this.mapviewer.getRoutingURL() !== '') {
      this.setupBubbleUI();
      this.setupRouteUI();
      if (this.useNavigation) {
        this.setupNavigationUI();
      }
    }

    jQuery('#floor_container').show();
    const globalModeButton = jQuery('#global_mode_button');
    const buildingModeButton = jQuery('#building_mode_button');
    const floorModeButton = jQuery('#floor_mode_button');
    const buildingSelector = jQuery('#change_building_select');
    const floorSelector = jQuery('#change_floor_select');

    const venueLayout = this.mapviewer.multiBuildingView.getVenueLayout();

    globalModeButton.on('click', () => {
      // go always to global mode to reset the view.
      const currentExploreState = this.mapviewer.multiBuildingView.getCurrentExploreState();
      this.mapviewer.multiBuildingView.goTo({
        mode: 'global',
        buildingID: currentExploreState.buildingID || this.mapviewer.multiBuildingView.DEFAULT,
      });
    });
    buildingModeButton.on('click', () => {
      this.mapviewer.multiBuildingView.goTo({
        mode: 'building',
        buildingID: (buildingSelector.val() === '' ? this.mapviewer.multiBuildingView.DEFAULT : buildingSelector.val()),
        floorID: (floorSelector.val() === '' ? this.mapviewer.multiBuildingView.DEFAULT : floorSelector.val()),
      });
    });
    buildingSelector.on('change', () => {
      if (this.value !== '') {
        const floorID = this.mapviewer.multiBuildingView.DEFAULT;
        const currentExploreState = this.mapviewer.multiBuildingView.getCurrentExploreState();
        if (currentExploreState.mode !== 'global') {
          const currentBuilding = venueLayout.buildingByID[currentExploreState.buildingID];
          const currentFloor = currentBuilding.floorByID[currentExploreState.floorID];
          if (typeof (currentFloor.connectedFloors[this.value]) !== 'undefined') {
            floorID = currentFloor.connectedFloors[this.value].floor;
          }
        }
        this.mapviewer.multiBuildingView.goTo({
          mode: 'building',
          buildingID: this.value,
          floorID,
        });
      }
    });
    floorModeButton.on('click', () => {
      const currentExploreState = this.mapviewer.multiBuildingView.getCurrentExploreState();
      this.mapviewer.multiBuildingView.goTo({
        mode: 'floor',
        buildingID: currentExploreState.buildingID,
        floorID: currentExploreState.floorID,
      });
    });
    floorSelector.on('change', () => {
      if (this.value !== '') {
        const currentExploreState = this.mapviewer.multiBuildingView.getCurrentExploreState();
        if (this.mapviewer.cameraDrivenExplorer.isEnabled) {
          this.mapviewer.multiBuildingView.goTo({
            mode: ((currentExploreState.mode == 'global') ? 'floor' : currentExploreState.mode),
            buildingID: currentExploreState.buildingID,
            floorID: this.value,
            noViewpoint: ((currentExploreState.mode == 'floor')),
          });
        } else {
          this.mapviewer.multiBuildingView.goTo({
            mode: ((currentExploreState.mode == 'global') ? 'building' : currentExploreState.mode),
            buildingID: currentExploreState.buildingID,
            floorID: this.value,
            noViewpoint: true,
          });
        }
      }
    });

    /*
    * Setup mode buttons: global, building, floor
    * Setup selectors: buildings, floor
    */
    const anyBuildingManyFloors = false;
    const hasManyBuildings = false;
    const hasOneBuilding = false;

    for (i in venueLayout.buildings) {
      if (venueLayout.buildings[i].floors.length > 1) {
        anyBuildingManyFloors = true;
        break;
      }
    }

    if (venueLayout.buildings.length > 1) {
      hasManyBuildings = true;
    } else if (venueLayout.buildings.length == 1) {
      hasOneBuilding = true;
    }

    // Global mode button
    if (venueLayout.hasGlobalLayer) {
      globalModeButton.show();
    } else {
      globalModeButton.hide();
    }

    // Building mode button
    if (anyBuildingManyFloors && this.mapviewer.multiBuildingView.buildingModeEnabled === true) {
      buildingModeButton.show();
    } else {
      buildingModeButton.hide();
    }

    // Building Selector
    if (hasManyBuildings || anyBuildingManyFloors) {
      buildingSelector.show();
    } else {
      buildingSelector.hide();
    }

    // Floor mode button and Floor Selector
    if (hasOneBuilding || hasManyBuildings) {
      floorModeButton.show();
      floorSelector.show();
    } else {
      floorModeButton.hide();
      floorSelector.hide();
    }

    const buildingsSorted = [];
    let i;
    for (i in venueLayout.buildingByID) {
      buildingsSorted.push(venueLayout.buildingByID[i]);
    }
    // descending displayIndex, since the order will be revered by selector
    buildingsSorted.sort((a, b) => ((a.displayIndex || 0) - (b.displayIndex || 0)));

    let f;
    buildingSelector.empty();
    buildingSelector.append(jQuery('<option/>', { value: '', text: 'Select building' }));
    for (i in buildingsSorted) {
      buildingSelector.append(jQuery('<option/>', {
        value: buildingsSorted[i].id,
        text: this.mapviewer.multiBuildingView.getLocalizedName(buildingsSorted[i].id),
      }));
    }

    this.mapviewer.on('MultiBuildingView.exploreStateWillChange', (ev) => {
      const targetExploreState = ev.args.target;
      switch (targetExploreState.mode) {
        case 'global':
          globalModeButton.addClass('selected');
          buildingModeButton.removeClass('selected');
          floorModeButton.removeClass('selected');
          break;
        case 'building':
          globalModeButton.removeClass('selected');
          buildingModeButton.addClass('selected');
          floorModeButton.removeClass('selected');
          break;
        case 'floor':
          globalModeButton.removeClass('selected');
          buildingModeButton.removeClass('selected');
          floorModeButton.addClass('selected');
          break;
      }

      // fill floors
      floorSelector.empty();
      if (typeof (targetExploreState.buildingID) !== 'undefined') {
        buildingSelector.val(targetExploreState.buildingID);
        floorSelector.empty();

        const building = venueLayout.buildingByID[targetExploreState.buildingID];
        if (building) {
          // floorSelector.append(jQuery('<option/>',{value: '', text: 'Select floor'}));
          for (f = (building.floors.length - 1); f >= 0; f--) {
            const floorID = building.floors[f].id;
            floorSelector.append(jQuery('<option/>', {
              value: floorID,
              text: this.mapviewer.multiBuildingView.getLocalizedName(floorID),
            }));
          }

          if (typeof (targetExploreState.floorID) !== 'undefined') {
            floorSelector.val(targetExploreState.floorID);
          } else {
            floorSelector.val('');
          }
        }
      } else {
        buildingSelector.val('');
      }
    });
  };

  createFloorButton = (targetFloor) => {
    const floorButtonID = `floor_link${targetFloor}`;
    const html = `<button class="vg_button change_floor" type="button" data-floor="${targetFloor}" id="${floorButtonID}">${targetFloor}</button> `;
    jQuery('#change_floor').append(html);
    this.floorButtonIDs[`floor${targetFloor}`] = `#${floorButtonID}`;
  };

  updateActiveFloorButton = (targetFloor) => {
    for (const i in this.floorButtonIDs) {
      jQuery(this.floorButtonIDs[i]).removeClass('selected');
    }
    jQuery(this.floorButtonIDs[`floor${targetFloor}`]).addClass('selected');
  };

  // #endregion
  // #region: Place data -----------------------------------------

  vgPlaces = {};
  doNotUseSetPlaceName = false; // On IE10 and IE11, mapviewer.setPlaceName can take a very long time

  fillComboboxes = () => {
    const $vgSearch = jQuery('#vg_search');
    const $vgRouteFrom = jQuery('#vg_route_from');
    const $vgRouteTo = jQuery('#vg_route_to');

    if ($vgSearch.length == 0 &&
      $vgRouteFrom.length == 0 &&
      $vgRouteTo.length == 0) {
      return;
    }

    if (Object.keys(this.vgPlaces).length === 0) {
      return;
    }

    const places = this.mapviewer.getPlaces();
    const additionalContent = [];
    for (const id in places) {
      let name = id;
      const place = vgPlaces[id];
      if (typeof (place) !== 'undefined') {
        name = place.name;
      }
      additionalContent.push('<option value="', id, '">', name, '</option>');
    }
    if (additionalContent.length > 0) {
      const allOptions = additionalContent.join('');

      $vgSearch.append(allOptions);
      $vgRouteFrom.append(allOptions);
      $vgRouteTo.append(allOptions);
    }
  };

  loadIDs = () => {
    // This is sample code to set the place's id as name.
    if (!this.doNotUseSetPlaceName) {
      const places = this.mapviewer.getPlaces();
      Object.keys(places).forEach((placeID) => {
        this.mapviewer.setPlaceName(placeID, {
          text: placeID,
          // textTextureHeight: 20, // for low memory consumption
          // visibilityRampStartInvisible: 800,
          // visibilityRampFullyInvisible: 1000
        });
      });
    }
    this.fillComboboxes();
    // we do it after filling comboboxes so it can preselect the values
    // test to see if src/dst were passed as parameters
    this.doRoutingFromURLParameters();
  };

  setMappingMode = (isMappingMode: boolean) => {
    this.isMappingMode = isMappingMode;
  }

  loadLabels = (data, colorMap) => {
    this.colorMap = colorMap;
    this.storesData = data;
    data.forEach((store) => {
      if (!store.idVisioglobes) {
        return;
      }
      store.idVisioglobes.forEach((id) => {
        const color = `#${Math.random().toString(16).slice(2, 8).toUpperCase()}`;
        this.mapviewer.setPlaceName(id, {
          text: store.luxName || store.mercuryName || store.retailerName,
          color: 0x000000,
          // textTextureHeight: 20, // for low memory consumption
          // visibilityRampStartInvisible: 800,
          // visibilityRampFullyInvisible: 1000
        });
        if (colorMap[id] && store.state !== reconciliationStates.OK) {
          this.mapviewer.setPlaceColor(this.mapviewer.getPlace(id), colorMap[id]);
        } else {
          this.mapviewer.setPlaceColor(this.mapviewer.getPlace(id), '#d6d6d6');
        }
      });
    });

    this.doRoutingFromURLParameters();
  };

  loadLabelsBaseMap = (data, colorMap) => {
    this.colorMap = colorMap;
    this.storesData = data;
    data.forEach((store) => {
      if (!store.idVisioglobes) {
        return;
      }
      store.idVisioglobes.forEach((id) => {
        const color = `#${Math.random().toString(16).slice(2, 8).toUpperCase()}`;
        this.mapviewer.setPlaceName(id, {
          text: store.luxName || store.mercuryName || store.retailerName,
          color: 0x000000,
          // textTextureHeight: 20, // for low memory consumption
          // visibilityRampStartInvisible: 800,
          // visibilityRampFullyInvisible: 1000
        });
        if (colorMap[id]) {
          this.mapviewer.setPlaceColor(this.mapviewer.getPlace(id), colorMap[id]);
        } else {
          this.mapviewer.setPlaceColor(this.mapviewer.getPlace(id), '#d6d6d6');
        }
      });
    });

    this.doRoutingFromURLParameters();
  };

  clearFootFalls = () => {
    this.footfallPois.forEach(poi => poi.remove());
    this.footfallPois = [];
    if (this.footfallPopup) {
      this.footfallPopup.remove();
    }
    this.footfallPopup = null;
  }

  clearFootFallPopUp = () => {
    if (this.footfallPopup) {
      this.footfallPopup.remove();
    }
    this.footfallPopup = null;
  }

  setSelectPoiCallback = (callback) => {
    this.selectPoiCallback = callback;
  }

  loadPois = (data) => {
    data.forEach((data) => {
      const poiCoordinates = this.mapviewer.convertLatLonToPoint({
        lat: data.storePolygon.centroid.x,
        lon: data.storePolygon.centroid.y,
      });
      this.footfallPois.push(this.mapviewer.addPOI({
        url: footfallImages[data.quantil],
        position: { x: poiCoordinates.x, y: poiCoordinates.y, z: 10 },
        id: data.storePolygon.vgId,
        floor: data.storePolygon.vgFloor,
        onObjectMouseUp: () => {
          this.selectPoiCallback(data.footfallData);
          if (this.footfallPopup && this.footfallPopupId) {
            this.footfallPopup.remove();
            this.footfallPopup = null;
            if (this.footfallPopupId === data.storePolygon.vgId) {
              this.footfallPopupId = null;
              return;
            }
          }
          this.footfallPopupId = data.storePolygon.vgId;
          const popup = document.getElementById('visioglobe-popup');
          popup.style = 'display: block';

          this.footfallPopup = this.mapviewer.addPOI({
            selector: '#visioglobe-popup',
            position: { x: poiCoordinates.x, y: poiCoordinates.y + 20, z: 10 },
            id: data.storePolygon.vgId,
            floor: data.storePolygon.vgFloor,
            scale: { x: 1, y: 1, z: 1 },
          });
          const entrance = autoQuantity(data.footfallData.entrances);
          const exit = autoQuantity(data.footfallData.exits);

          popup.innerHTML = `${'<div>' +
            'Entrances: '}${entrance.value}${entrance.quantity
          }<br/>` +
            `Exits: ${exit.value}${entrance.quantity
            }<br/>` +
            `Nb Months: ${data.footfallData.nbMonth
            }</div>`;
        },
        scale: { x: 10, y: 10, z: 10 },
      }));
    });
  }

  loadLabelNoColor = (data, colorMap) => {
    this.colorMap = colorMap;
    this.storesData = data;
    data.forEach((store) => {
      if (!store.idVisioglobes) {
        return;
      }
      store.idVisioglobes.forEach((id) => {
        const color = `#${Math.random().toString(16).slice(2, 8).toUpperCase()}`;
        this.mapviewer.setPlaceName(id, {
          text: store.storeName || '',
          color: 0x000000,
          // textTextureHeight: 20, // for low memory consumption
          // visibilityRampStartInvisible: 800,
          // visibilityRampFullyInvisible: 1000
        });
      });
    });
    // combo boxes needs to be called after filling vgPlaces so it can use the real place name on the menu.
    // fillComboboxes();

    // after filling comboboxes so it can preselect the values
    this.doRoutingFromURLParameters();
  };

  updateStoreColors = (colorSelected) => {
    Object.keys(this.colorMap).forEach((storeId) => {
      if (colorSelected && (colorSelected.length === 0 || colorSelected.includes(this.colorMap[storeId]))) {
        this.currentlySelectedColors = colorSelected;
        this.mapviewer.setPlaceColor(this.mapviewer.getPlace(storeId), this.colorMap[storeId]);
      } else {
        this.mapviewer.setPlaceColor(this.mapviewer.getPlace(storeId), '#D6D6D6');
      }
    });
  };

  updateColors = (colorMap) => {
    colorMap.forEach((storeColor) => {
      if (storeColor.storeIds) {
        storeColor.storeIds.forEach((ids) => {
          this.mapviewer.setPlaceName(ids, {
            text: storeColor.storeName || '',
            color: storeColor.textColor || 0x000000,
            // textTextureHeight: 20, // for low memory consumption
            // visibilityRampStartInvisible: 800,
            // visibilityRampFullyInvisible: 1000
          });
          this.colorMap[ids] = storeColor.color;
          // if the store will stay selected, the color doesn't change but the colorMap does change so that it will have the right color when deselected
          if (!storeColor.staySelected) {
            this.mapviewer.setPlaceColor(this.mapviewer.getPlace(ids), storeColor.color);
          }
        });
      }
    });
  };

  loadPlaces = () => {
    const extraData = this.mapviewer.getExtraData();
    if (!extraData || typeof (extraData.resources) === 'undefined') {
      return false;
    }

    let language = 'default';
    if (typeof (this.query.language) !== 'undefined' &&
      typeof (extraData.resources[language]) !== 'undefined') {
      language = this.query.language;
    }
    if (typeof (extraData.resources[language]) === 'undefined') {
      return false;
    }

    const { places } = extraData.resources[language].localized.locale[language];
    if (typeof (places) === 'undefined') {
      return false;
    }

    Object.keys(places).forEach((placeID) => {
      const place = places[placeID];
      vgPlaces[placeID] = {
        name: place.name,
        description: place.description,
      };
      if (!doNotUseSetPlaceName) {
        const options = {
          text: place.name,
          // url: place.icon, // not included in web bundle yet
          textTextureHeight: 128,
          // textTextureHeight: 64, // for limited platforms or big maps
          zoomScaleFactor: 1.5,
          multiline: true,
        };
        this.mapviewer.setPlaceName(placeID, options);
      }
    });

    // combo boxes needs to be called after filling vgPlaces so it can use the real place name on the menu.
    fillComboboxes();
    // after filling comboboxes so it can preselect the values
    doRoutingFromURLParameters();

    return true;
  };

  // #endregion
  // #region: Place activation / highlight -----------------------------------------

  highlightedPlace = null;
  activePlace = null;

  setActivePlace = (place) => {
    if (place === false) {
      return;
    }

    // If the place is actually a POI, find the place with the same id.
    if (place.vg && place.vg.poi) {
      place = this.mapviewer.getPlace(place.options ? place.options('id') : place.vg.id);
      if (place === false) {
        return;
      }
    }

    this.resetActivePlace();
    if (typeof (place) !== 'undefined' && place !== false && !place.vg.poi) {
      const places = this.storesData.filter(store => store.idVisioglobes && store.idVisioglobes.filter(idVisio => idVisio === place.vg.id).length > 0)[0];

      if (!places) {
        return;
      }
      if (this.isMappingMode && places.state === reconciliationStates.OK) {
        return;
      }
      places.idVisioglobes.forEach(id => this.mapviewer.setPlaceColor(this.mapviewer.getPlace(id), this.activePlaceColor));
      // this.mapviewer.setPlaceColor(place, this.activePlaceColor);
      this.activePlace = places;
      // a place cannot be highlighted and active at the same time.
      // if (this.highlightedPlace == this.activePlace) {
      //   this.highlightedPlace = null;
      // }
      if (this.selectStoreCallback) {
        this.selectStoreCallback(places, place);
      }
    }
  };

  resetActivePlace = () => {
    if (this.activePlace !== null) {
      this.activePlace.idVisioglobes.forEach((id) => {
        if (this.colorMap[id]
          && (this.currentlySelectedColors.length === 0
            || !!this.currentlySelectedColors
              .filter(color => color === this.colorMap[id])[0])) {
          this.mapviewer.setPlaceColor(this.mapviewer.getPlace(id), this.colorMap[id]);
        } else {
          this.mapviewer.setPlaceColor(this.mapviewer.getPlace(id), '#D6D6D6');
        }
        this.activePlace = null;
      });
    }
  };

  setHighlightedPlace = (place) => {
    if (place === false) {
      return;
    }

    if (place instanceof Array ||
      (place.vg && place.vg.poi)) {
      return;
    }

    if (place == this.highlightedPlace) {
      return;
    }

    this.resetHighlightedPlace();
    if (typeof (place) !== 'undefined' && place != this.activePlace) {
      this.mapviewer.setPlaceColor(place, 0xFFFFFF - place.vg.originalColor);
      this.highlightedPlace = place;
    }
  };

  resetHighlightedPlace = () => {
    if (this.highlightedPlace !== null) {
      this.mapviewer.resetPlaceColor(this.highlightedPlace);
      this.highlightedPlace = null;
    }
  };

  selectPlace = (placeName, callback) => {
    const place = this.mapviewer.getPlace(placeName);
    this.resetActivePlace();
    if (place !== false) {
      this.gotoFloorAndPosition(place.vg.floor, place, () => {
        this.setActivePlace(place);
        callback();
      });
    }
  };

  // #endregion
  // #region: Bubble management -----------------------------------------

  placeBubble;

  openPlaceBubble = (placeOrPOI) => {
    let result = false;
    if (typeof (placeOrPOI) !== 'undefined' && placeOrPOI !== false) {
      if (typeof (placeOrPOI) === 'string') {
        placeOrPOI = this.mapviewer.getPlace(placeOrPOI);
        if (placeOrPOI === false) {
          return result;
        }
      }
      // destroy previous bubble.
      closePlaceBubble();
      let id;
      let position;
      let floor;
      if (typeof (placeOrPOI.vg.id) !== 'undefined') {
        id = placeOrPOI.vg.id;
        position = placeOrPOI.vg.position;
        floor = placeOrPOI.vg.floor;
      } else if (placeOrPOI.vg.poi) {
        id = placeOrPOI.options('id');
        position = placeOrPOI.options('position');
        floor = placeOrPOI.options('floor');
      } else {
        return;
      }

      // alignment, bottom middle
      placeBubble = this.mapviewer.addPOI({
        selector: '#place_bubble',
        floor,
        position,
        alignment: { x: 0, y: 1.0 },
      });
      if (typeof (vgPlaces[id]) !== 'undefined') {
        jQuery('#place_bubble_title').html(vgPlaces[id].name);
        if (typeof (vgPlaces[id].description) !== 'undefined') {
          jQuery('#place_bubble_description').html(vgPlaces[id].description);
          jQuery('#place_bubble_info_button').show();
        } else {
          jQuery('#place_bubble_info_button').hide();
        }
      } else {
        jQuery('#place_bubble_title').html(`ID: ${id}`);
        jQuery('#place_bubble_info_button').hide();
      }
      jQuery('#place_bubble_description').hide();
      jQuery('#place_bubble_set_origin').show();
      jQuery('#place_bubble_set_destination').show();
      jQuery('#place_bubble_set_waypoint').show();
      if (this.mapviewer.getRoutingNode(id) !== false) {
        // node is routable
        jQuery('#place_bubble_set_origin').attr('vg_id', id).prop('disabled', false).css('opacity', '1.0');
        jQuery('#place_bubble_set_destination').attr('vg_id', id).prop('disabled', false).css('opacity', '1.0');
        jQuery('#place_bubble_set_waypoint').attr('vg_id', id).prop('disabled', false).css('opacity', '1.0');
      } else {
        // node is not routable
        jQuery('#place_bubble_set_origin').attr('vg_id', '').prop('disabled', true).css('opacity', '0.4');
        jQuery('#place_bubble_set_destination').attr('vg_id', '').prop('disabled', true).css('opacity', '0.4');
        jQuery('#place_bubble_set_waypoint').attr('vg_id', '').prop('disabled', true).css('opacity', '0.4');
      }
      result = true;
    }
    return result;
  }

  openGoodwillPopup = (placeOrPOI, htmlPopupText) => {
    let result = false;
    if (typeof (placeOrPOI) !== 'undefined' && placeOrPOI !== false) {
      if (typeof (placeOrPOI) === 'string') {
        placeOrPOI = this.mapviewer.getPlace(placeOrPOI);
        if (placeOrPOI === false) {
          return result;
        }
      }
      // destroy previous bubble.
      this.closePlaceBubble();
      let position;
      if (typeof (placeOrPOI.vg.id) !== 'undefined') {
        position = placeOrPOI.vg.position;
      } else if (placeOrPOI.vg.poi) {
        position = placeOrPOI.options('position');
      } else {
        return;
      }

      const popup = document.getElementById('visioglobe-popup');
      popup.style = 'display: block; max-width: 75%; max-height: 60%';
      this.placeBubble = this.mapviewer.addPOI({
        selector: '#visioglobe-popup',
        position: {
          x: position.x,
          y: position.y + 10,
          z: position.z,
        },
      });
      popup.innerHTML = htmlPopupText;

      jQuery('#goodwill_popup_close_button').on('click', null, () => {
        this.closePlaceBubble();
        return false;
      });

      result = true;
    }
    return result;
  }

  closePlaceBubble = () => {
    if (this.placeBubble) {
      this.placeBubble.remove();
      this.placeBubble = false;
    }
  };

  // #endregion
  // #region: Route / navigation management -----------------------------------------

  currentNavigation;
  currentRoute = null;
  routeStartEnd = null; // dummy route object for having start and end as we click
  routeStartID = false;
  routeEndID = false;
  routeWaypointIDs = [];

  doRouting(srcPlace, dstPlace) {
    // if no parameters use values on combobox
    if (srcPlace === undefined || srcPlace === false) {
      const jc = jQuery('#vg_route_from')[0];
      if (typeof (jc) === 'undefined' || jc.selectedIndex == -1) {
        return;
      }
      const opt = jc[jc.selectedIndex];
      const { value } = opt;
      srcPlace = value;
    }
    if (dstPlace === undefined) {
      const jc = jQuery('#vg_route_to')[0];
      if (jc.selectedIndex == -1) {
        return;
      }
      const opt = jc[jc.selectedIndex];
      const { value } = opt;
      dstPlace = value;
    }

    if (srcPlace == '' || dstPlace == '' ||
      srcPlace === false || dstPlace === false ||
      (Array.isArray(dstPlace) && dstPlace.length == 1 && dstPlace[0] === false)) {
      return;
    }

    const lRouteRequest = {};
    lRouteRequest.src = srcPlace;
    lRouteRequest.dst = dstPlace;

    lRouteRequest.routingParameters = {};
    if (accessibleRoute) {
      if (this.appParams !== null &&
        typeof (this.appParams.routingParameters) !== 'undefined' &&
        typeof (this.appParams.routingParameters.excludedAttributes) !== 'undefined' &&
        typeof (this.appParams.routingParameters.excludedModalities) !== 'undefined') {
        lRouteRequest.routingParameters.excludedAttributes = this.appParams.routingParameters.excludedAttributes;
        lRouteRequest.routingParameters.excludedModalities = this.appParams.routingParameters.excludedModalities;
      } else {
        lRouteRequest.routingParameters.excludedAttributes = ['escalator', 'stairway'];
      }
    }

    // If you did not want to display anything special with a modalityParameters
    // lRouteRequest.routingParameters.remapResultingModality: {'Travelator': 'pedestrian'}

    lRouteRequest.computeNavigation = useNavigation;

    // Override certain navigation parameters
    lRouteRequest.navigationParameters = lRouteRequest.navigationParameters || {};
    lRouteRequest.navigationParameters.modalityParameters = lRouteRequest.navigationParameters.mModalityParameters || {};
    lRouteRequest.navigationParameters.modalityParameters.shuttle = lRouteRequest.navigationParameters.modalityParameters.shuttle || {};
    lRouteRequest.navigationParameters.modalityParameters.shuttle.straightAngleThreshold = lRouteRequest.navigationParameters.modalityParameters.shuttle.straightAngleThreshold || 180.0;
    lRouteRequest.navigationParameters.modalityParameters.shuttle.distanceFromCouloirThreshold = lRouteRequest.navigationParameters.modalityParameters.shuttle.distanceFromCouloirThreshold || 1000.0;
    // Uncomment below if you don't want to use the defaults.
    // lRouteRequest.navigationParameters.algorithm = 'auto';
    // lRouteRequest.navigationParameters.algorithm = 'intersectionAlgorithm';
    // set firstNodeAsIntersection to be true if you want a turn right/left instruction when exiting a POI

    if (typeof (this.query.firstnode) !== 'undefined') {
      lRouteRequest.navigationParameters.firstNodeAsIntersection = true;
    }

    /*
    const defaultStraightAngleThreshold = 30.0;
    if (query.angle)
    {
      defaultStraightAngleThreshold = query.angle;
    }

    // Changed default straightAngleThreshold
    const modalities = mapviewer.getRoutingModalities();
    const modalityParameters = lRouteRequest.navigationParameters.modalityParameters;
    for (const i in modalities)
    {
      const modality = modalities[i];
      modalityParameters[modality] = modalityParameters[modality] || {};
      modalityParameters[modality].straightAngleThreshold = modalityParameters[modality].straightAngleThreshold || defaultStraightAngleThreshold;
      // modalityParameters[modality].nearPlacesThreshold = 10;
    }
    */
    // Use default (on 1.7.17 default changed to mergeFloorChangeInstructions -> true)
    // old behavior with false: 2 instructions: 1) go straight, 2) go up (or you have arrived)
    //               with true: 1 instruction:  1) go straight then go up (you will have arrived)
    // lRouteRequest.navigationParameters.mergeFloorChangeInstructions = false;

    if (typeof (this.query.nomerge) !== 'undefined') {
      lRouteRequest.navigationParameters.mergeFloorChangeInstructions = false;
    }
    if (typeof (this.query.language) !== 'undefined') {
      lRouteRequest.language = this.query.language;
    }

    // reset start end pins
    if (routeStartEnd != null) {
      this.routeStartEnd.remove();
    }

    this.mapviewer.computeRoute(lRouteRequest)
      .then((route) => {
        if (this.currentRoute != null) {
          this.currentRoute.remove();
          this.currentRoute = null;
        }
        if (currentNavigation != null) {
          resetNavigationUI();
          this.currentNavigation.remove();
          this.currentNavigation = null;
        }

        if (route.data.status && route.data.status != 200) {
          clearRouting();
          return Promise.reject(`Sorry, no route available between ${route.request.src} and ${route.request.dst}.`);
        }

        route.data.pathColor = this.pathColor;
        this.currentRoute = new MyRoute(this.mapviewer, route.data);
        if (this.currentRoute.isValid()) {
          this.currentRoute.show();
          if (this.useNavigation) {
            this.currentNavigation = new MyNavigation(this.mapviewer, route.data, vgPlaces);
            this.updateNavigationUI();
            this.toggleNavigationUI();
          }

          setActivePlace(this.mapviewer.getPlace(srcPlace));
          const viewpoint = currentRoute.getInitialViewpointPosition();
          const floorname = currentRoute.getInitialFloor();
          return gotoFloorAndPosition(floorname, viewpoint);
        }

        return Promise.reject(`Problems rendering the route between ${route.request.src} and ${route.request.dst}.`);
      })
      .catch((e) => {
        clearRouting();
      });
  }

  searchRoute(srcPlace, dstPlace) {
    if (
      !srcPlace
      || !dstPlace
      || (Array.isArray(dstPlace) && dstPlace.length === 1 && !dstPlace[0])
    ) {
      return null;
    }

    const lRouteRequest = {};
    lRouteRequest.src = srcPlace;
    lRouteRequest.dst = dstPlace;

    lRouteRequest.routingParameters = {};

    lRouteRequest.computeNavigation = true;

    const shuttle = {
      straightAngleThreshold: 180.0,
      distanceFromCouloirThreshold: 1000.0,
    };

    const modalityParameters = {
      shuttle,
    };

    lRouteRequest.navigationParameters = { modalityParameters };
    return this.mapviewer.computeRoute(lRouteRequest)
      .then((route) => {
        if (route.data.status && route.data.status !== 200) {
          return Promise.resolve(null);
        }
        return Promise.resolve(this.routeBean(route.data));
      });
  }

  routeBean(data) {
    const res = {};
    res.distance = data.length;
    res.idVisioglobesSrc = data.request.src;
    res.idVisioglobesTarget = data.request.dst;
    return res;
  }

  searchRoutes(placesSrc, placesDst) {
    const routesPromises = [];
    placesSrc.forEach((src) => {
      placesDst.forEach((dst) => {
        const promise = this.searchRoute(src, dst);
        if (promise) {
          routesPromises.push(promise);
        }
      });
    });
    return Promise.all(routesPromises)
      .then(response => response);
  }

  /**
   * needs to be called after comboboxes have been filled.
   * this method is complicated by the fact that we want to update the UI
   * and that the doRouting() function uses the UI for its parameters
   */
  doRoutingFromURLParameters = () => {
    // Compute routing is passed as parameter
    if (typeof this.query.src !== 'undefined' && typeof this.query.dst !== 'undefined') {
      routeStartID = this.query.src;
      routeEndID = this.query.dst;

      // preselect comboboxes if exist
      const srcBox = jQuery('#vg_route_from');
      const dstBox = jQuery('#vg_route_to');

      if (srcBox.length == 1 && dstBox.length == 1) {
        const srcIndex = jQuery(`option[value="${this.query.src}"]`, srcBox).index();
        const dstIndex = jQuery(`option[value="${this.query.dst}"]`, dstBox).index();
        if (srcIndex != -1 && dstIndex != -1) {
          const srcBox0 = srcBox[0];
          const dstBox0 = dstBox[0];
          srcBox0.selectedIndex = srcIndex;
          dstBox0.selectedIndex = dstIndex;

          jQuery('#vg_route_from-input').val(jQuery(srcBox0[srcIndex]).val());
          jQuery('#vg_route_to-input').val(jQuery(dstBox0[dstIndex]).val());
        }
      }
      // do actual routing.
      if (typeof this.query.waypoint !== 'undefined') {
        return doRouting(`${this.query.src}`, [`${this.query.waypoint}`, `${this.query.dst}`]);
      }

      return doRouting(`${this.query.src}`, `${this.query.dst}`);
    }
  }

  /*
   * removes currentRoute
   * removes currentNavigation
   * resets start/end route points.
   */
  clearRouting = () => {
    // remove current Route
    if (currentRoute != null) {
      currentRoute.remove();
      currentRoute = null;
    }

    // hide navigation instructions
    if (useNavigation) {
      hideNavigationUI(() => {
        jQuery('#instructions').css('visibility', 'hidden');
        if (currentNavigation != null) {
          resetNavigationUI();
          currentNavigation.remove();
          currentNavigation = null;
        }
      });
    }

    const srcBox = jQuery('#vg_route_from');
    if (srcBox.length == 1) {
      srcBox[0].selectedIndex = -1;
      jQuery('#vg_route_from-input').val('');
    }
    routeStartID = false;

    const dstBox = jQuery('#vg_route_to');
    if (dstBox.length == 1) {
      dstBox[0].selectedIndex = -1;
      jQuery('#vg_route_to-input').val('');
    }
    routeEndID = false;
    routeWaypointIDs = [];

    jQuery('#route_clear').hide();
  }

  // #endregion
  // #region: Pointer events -----------------------------------------

  statusbarTimeout = null;

  onObjectMouseUp = (event, element) => {
    // vg is only defined if the event occured on a surface (as opposed to icons or models)
    if (element.vg && typeof (element.vg.id) !== 'undefined') {
      jQuery('#vg_search-input').val(element.vg.id);
    }

    // openPlaceBubble(element);
    this.setActivePlace(element);
  };

  // element can be a Place or a POI
  onObjectMouseOver(event, element) {
    // We avoid highlighting POIs that don't have a Place with the same ID.
    if (element.vg && element.vg.poi) {
      // element is a POI (it should have options() method)
      element = element.options && this.mapviewer.getPlace(element.options('id'));
      if (!element) {
        return false;
      }
    }

    if (statusbarTimeout !== null) {
      clearTimeout(statusbarTimeout);
      statusbarTimeout = null;
    }

    jQuery('#vg_statusbar').animate({
      top: '-100px',
    });

    setHighlightedPlace(element);

    const html = '';
    if (typeof (vgPlaces[element.vg.id]) !== 'undefined') {
      const { name } = vgPlaces[element.vg.id];
      html += `<h4>Element name=${name}</h4>`;
    } else {
      html += `<h4>Element ID=${element.vg.id}</h4>`;
    }
    jQuery('#vg_statusbar .info').html(html);
  }

  // We dismiss status bar on any mouse out event.
  onObjectMouseOut(event, element) {
    if (this.statusbarTimeout === null) {
      const dismissStatusBar = true;

      if (dismissStatusBar) {
        this.statusbarTimeout = setTimeout(() => {
          jQuery('#vg_statusbar').clearQueue().animate({
            top: '70px',
          }, {
            complete() {
              jQuery('#vg_statusbar .info').html('');
            },
          });
        }, 1000);
      } else {
        jQuery('#vg_statusbar .info').html('');
      }
    }

    this.resetHighlightedPlace();
  }

  // #endregion
  // #region: Utils -----------------------------------------

  logVisioWebTitle = () => {
    console.log(
      `%c VisioWeb %c v${this.mapviewer.version}-${this.mapviewer.revision} %c`,
      'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
      'background:#00c5eb ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
      'background:transparent',
    );
  };

  isWebGLSupported = () => {
    let result = false;
    if (window.WebGLRenderingContext) {
      let cvsEl;
      let ctx;
      cvsEl = document.createElement('canvas');
      ctx = cvsEl.getContext('webgl') || cvsEl.getContext('experimental-webgl');

      if (ctx) {
        result = true;
        // This makes sure the Browser supports WebGL and that it can create the WebGL context
      }
    }
    return result;
  };

  updateProgress(percentage) {
    jQuery('#progress').show();
    if (percentage) {
      if (this && (this.animationValue || this.animationOffset)) {
        jQuery('#progress input.knob').trigger('configure', { angleOffset: 0 });
      }
      if (this && this.animationValue) {
        this.animationValue.stop();
        this.animationValue = undefined;
      }
      if (this && this.animationOffset) {
        this.animationOffset.stop();
        this.animationOffset = undefined;
      }
      const percentText = (percentage * 100).toFixed(2);
      jQuery('#progress input.knob').val(percentText).trigger('change');
    }
  }

  // Tested Windows Phone 10, iOS 9, Android 4.4, for Windows 8 you would need to use MS pointer events.
  checkMoreThanTwoTouches = (event) => {
    if (event && event.touches && event.touches.length > 2) {
      // update this alert with your own message or framework.
      alert('For best user experience, use only two fingers');
      // Only warn the user once.
      document.removeEventListener('touchstart', checkMoreThanTwoTouches);
    }
  }

  // document.addEventListener('touchstart', checkMoreThanTwoTouches, false);

  onRemoteMessage(event) {
    return Promise.resolve(event.data)
      .then(JSON.parse)
      .then((message) => {
        if (typeof (message.method) === 'undefined') {
          return Promise.reject('message without method');
        }

        let result;
        if (message.method === 'goTo') {
          result = this.mapviewer.camera[message.method].apply(this.mapviewer.camera, message.arguments);
        } else if (typeof (this.mapviewer[message.method]) === 'function') {
          result = this.mapviewer[message.method].apply(this.mapviewer, message.arguments);
        } else {
          result = this.mapviewer[message.method];
        }

        return Promise.resolve(result)
          .then((response) => {
            parent.postMessage(JSON.stringify({
              requestID: message.requestID,
              response,
            }), '*');
          })
          .catch((reason) => {
            parent.postMessage(JSON.stringify({
              requestID: message.requestID,
              reason,
            }), '*');
          });
      })
      .catch((e) => {
        console.log(`Unhandled message: ${e}`);
      });
  }

  getActivePlace() {
    return this.activePlace;
  }

// #endregion
}
